/* YOUY - comparador de lente + blocos da PDP que trocam com a cor */
(function(){
  function initCmp(root){
    if(root.dataset.yyOn) return; root.dataset.yyOn='1';
    var area=root.querySelector('.youy-cmp__area'); if(!area) return;
    function setPos(p){ p=Math.max(0,Math.min(100,p)); area.style.setProperty('--pos',p.toFixed(1)+'%'); area.setAttribute('aria-valuenow',Math.round(p)); }
    function fromX(x){ var r=area.getBoundingClientRect(); if(r.width) setPos((x-r.left)/r.width*100); }
    area.addEventListener('pointermove',function(e){ if(e.pointerType==='mouse'||e.buttons) fromX(e.clientX); });
    area.addEventListener('pointerdown',function(e){ area.setPointerCapture(e.pointerId); fromX(e.clientX); e.preventDefault(); });
    area.addEventListener('keydown',function(e){ var c=parseFloat(area.getAttribute('aria-valuenow'))||50; if(e.key==='ArrowLeft'){setPos(c-4);e.preventDefault();} else if(e.key==='ArrowRight'){setPos(c+4);e.preventDefault();} });
  }
  function boot(){ document.querySelectorAll('.youy-cmp').forEach(initCmp); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);

  // blocos com data-youy-live: troca pelo HTML novo que o tema busca ao mudar de cor
  document.addEventListener('variant:update',function(e){
    var html=e.detail && e.detail.data && e.detail.data.html; if(!html) return;
    document.querySelectorAll('[data-youy-live]').forEach(function(el){
      var n=html.querySelector('[data-youy-live="'+el.getAttribute('data-youy-live')+'"]');
      if(n) el.replaceWith(n.cloneNode(true));
    });
    // galeria da PDP: garante a troca pelas fotos da cor nova (o listener do tema se perde quando a galeria é movida no DOM)
    var ng=html.querySelector('media-gallery'), og=e.target && e.target.closest && e.target.closest('.shopify-section') && e.target.closest('.shopify-section').querySelector('media-gallery');
    if(ng && og){ setTimeout(function(){ if(og.isConnected) og.replaceWith(ng); },0); }
  });

  // vitrine: o app de cores troca foto e preço do card, mas não o "de/por" nem as parcelas.
  // Busca a variante clicada em /products/handle.js e redesenha preço + parcelas.
  var cache={};
  function fmt(c){ c=Math.round(c); var r=Math.floor(c/100), cc=c%100; var s=String(r).replace(/\B(?=(\d{3})+(?!\d))/g,'.'); return 'R$ '+s+(cc?','+(cc<10?'0':'')+cc:''); }
  function prod(h){ if(!cache[h]) cache[h]=fetch('/products/'+h+'.js').then(function(r){return r.json();}); return cache[h]; }
  function atualizaCard(card){
    var a=card.querySelector('a[href*="/products/"]'); if(!a) return;
    var u=new URL(a.href, location.origin), vid=u.searchParams.get('variant'); if(!vid) return;
    var h=u.pathname.split('/products/')[1]; if(!h) return; h=h.split('/')[0];
    prod(h).then(function(p){
      var v=(p.variants||[]).find(function(x){return String(x.id)===vid;}); if(!v) return;
      var pc=card.querySelector('product-price [ref="priceContainer"]'); if(!pc) return;
      var reg=pc.querySelector('.price__regular'), sale=pc.querySelector('.price__sale');
      if(reg && sale){
        if(v.compare_at_price && v.compare_at_price>v.price){
          reg.classList.add('price__hidden'); sale.classList.remove('price__hidden');
          var ps=sale.querySelector('.price-item--sale'), pr=sale.querySelector('.compare-at-price');
          if(ps) ps.textContent=fmt(v.price); if(pr) pr.textContent=fmt(v.compare_at_price);
        } else {
          sale.classList.add('price__hidden'); reg.classList.remove('price__hidden');
          var pp=reg.querySelector('.price'); if(pp) pp.textContent=fmt(v.price);
        }
      }
      var par=pc.querySelector('.youy-parcelas'); if(par) par.textContent='ou 6x de '+fmt(v.price/6)+' sem juros';
    }).catch(function(){});
  }
  /* fotos do card: só a cor selecionada */
  function guardaImgs(card){
    card.querySelectorAll('.card-gallery slideshow-slide[data-yy-sku] img').forEach(function(im){
      if(im.dataset.yySrc==null){ im.dataset.yySrc=im.getAttribute('src')||''; im.dataset.yySrcset=im.getAttribute('srcset')||''; }
    });
  }
  function fotosCard(card){
    var g=card.querySelector('.card-gallery'); if(!g) return;
    var js=g.querySelector('script[data-yy-card-skus]'); if(!js) return;
    var map; try{ map=JSON.parse(js.textContent); }catch(err){ return; }
    var a=g.querySelector('a[ref="cardGalleryLink"]')||card.querySelector('a[href*="/products/"]'); if(!a) return;
    var vid=new URL(a.href, location.origin).searchParams.get('variant'); var sku=vid&&map[vid]; if(!sku) return;
    var ss=g.querySelector('slideshow-component'); if(!ss) return;
    var slides=[].slice.call(ss.querySelectorAll('slideshow-slide[data-yy-sku]'));
    if(!slides.some(function(sl){return sl.dataset.yySku===sku;})) return;
    if(ss.dataset.yySku===sku) return;
    var first=null;
    slides.forEach(function(sl){
      sl.querySelectorAll('img[data-yy-src]').forEach(function(im){
        if(im.dataset.yySrcset) im.setAttribute('srcset',im.dataset.yySrcset); else im.removeAttribute('srcset');
        im.setAttribute('src',im.dataset.yySrc);
      });
      var on=sl.dataset.yySku===sku; sl.hidden=!on;
      if(on){ sl.querySelectorAll('img[loading="lazy"]').forEach(function(im){im.loading='eager';}); if(!first) first=sl; }
    });
    ss.dataset.yySku=sku;
    if(first){
      try{ ss.select({id:first.getAttribute('slide-id')},undefined,{animate:false}); }catch(err){}
      var vis=slides.filter(function(sl){return !sl.hidden;}).length;
      var arrows=g.querySelector('slideshow-arrows'); if(arrows) arrows.style.display=vis>1?'':'none';
    }
  }
  document.addEventListener('click',function(e){
    var sw=e.target.closest && e.target.closest('.swatches-globo--list'); if(!sw) return;
    var card=sw.closest('product-card'); if(!card) return;
    guardaImgs(card);
    [60,200,450,1200].forEach(function(t){ setTimeout(function(){fotosCard(card);},t); });
    setTimeout(function(){atualizaCard(card);},450); setTimeout(function(){atualizaCard(card);},1200);
  },true);
  function guardaTodos(){ document.querySelectorAll('product-card').forEach(guardaImgs); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',guardaTodos); else guardaTodos();
})();
